import {
  Box,
  Button,
  Checkbox,
  Flex,
  Input,
  Select,
  Skeleton,
  Text,
  Textarea,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { IoIosAddCircle } from "react-icons/io";
import { BiSend } from "react-icons/bi";
import moment from "moment";
export const ModalInteracao = (dados) => {
  let [dataRetorno, setDataRetorno] = useState(null);
  let [funilVendas, setFunilVendas] = useState(null);
  let [perdido, setPerdido] = useState(false);
  let [motivoPerdida, setMotivoPerdida] = useState(null);
  let [observacao, setObservacao] = useState(null);

  const Enviar = () => {
    dados.enviarTMK({
      dataRetorno: dataRetorno,
      funilVendas: funilVendas,
      motivoPerdida: motivoPerdida,
      observacao: observacao,
    });
  };

  const dadosSortedy = dados.historico.sort((a, b) => {
    return new Date(b.data_historico) - new Date(a.data_historico);
  });

  return (
    <Box mt="2rem" ml="auto" mr="auto" w="70%" h="500px" overflowY={"auto"}>
      {!dados.visualizar ? (
        <>
          <Flex>
            <Text fontFamily="Akrobat ExtraBold" fontSize="lg" mt="0.2rem">
              Data para retornar:
            </Text>
            <Input
              bgColor="#F0F4F5"
              focusBorderColor="#03a9f4"
              type="date"
              ml="0.3rem"
              size="sm"
              w="15%"
              onChange={(e) => setDataRetorno(e.target.value)}
            />
            <Text ml="4rem" fontFamily="Akrobat ExtraBold" fontSize="lg">
              Funil de Vendas:
            </Text>
            <Select
              bgColor="#F0F4F5"
              focusBorderColor="#03a9f4"
              iconColor="#03a9f4"
              ml="0.3rem"
              size="sm"
              w="15%"
              onChange={(e) =>
                setFunilVendas(
                  e.target.options[e.target.options.selectedIndex].value
                )
              }
            >
              <option value={0}></option>
              {dados.funilVendas.map((item) => {
                return (
                  <option value={item.codigo_funil_venda}>
                    {item.tipo_funil_venda}
                  </option>
                );
              })}
            </Select>
          </Flex>

          <Flex mt="1.5rem">
            <Text color="#03a9f4" fontFamily="Akrobat ExtraBold" fontSize="lg">
              Registrar Histórico:
            </Text>
            <Textarea
              bgColor="#F0F4F5"
              ml="0.3rem"
              w="62.7%"
              focusBorderColor="#03a9f4"
              size="sm"
              resize="none"
              onChange={(e) => setObservacao(e.target.value)}
            />
            <Button
              mt="2.5rem"
              ml="0.6rem"
              color="#03a9f4"
              _hover={{ bgColor: "#d6eef7" }}
              _active={{ bgColor: "#d6eef7" }}
              variant="outline"
              borderColor="#03a9f4"
              boxShadow="none !important"
              size="md"
              rightIcon={<BiSend color="#03a9f4" />}
              onClick={() => Enviar()}
            >
              Salvar
            </Button>
          </Flex>
        </>
      ) : (
        <></>
      )}

      {dadosSortedy.map((item) => {
        return (
          <Box>
            <Flex mt="1rem">
              <Text fontFamily="Akrobat ExtraBold" ml="1rem" fontSize="lg">
                Data do Histórico:
              </Text>
              <Text mt="0.2rem" ml="0.2rem">
                {moment(item.data_historico).format("DD/MM/YYYY")}
              </Text>
              <Text fontFamily="Akrobat ExtraBold" ml="1rem" fontSize="lg">
                Horário:
              </Text>
              <Text mt="0.2rem" ml="0.2rem">
                {moment(item.data_historico).format("hh:mm:ss")}
              </Text>
              <Text fontFamily="Akrobat ExtraBold" ml="1rem" fontSize="lg">
                Data para retornar:
              </Text>
              <Text ml="0.5rem">
                {moment(item.data_retorno).format("DD/MM/YYYY")}
              </Text>
            </Flex>
            <Flex mt="0.5rem">
              <Text fontFamily="Akrobat ExtraBold" fontSize="lg">
                Observações:
                <Skeleton
                  mt="1rem"
                  startColor="pink.500"
                  endColor="#03a9f4"
                  height="1px"
                />
              </Text>
              <Text ml="0.3rem" mt="0.2rem" width={"80%"}>
                {item.observacao}
                <Skeleton
                  mt="1rem"
                  startColor="pink.500"
                  endColor="#03a9f4"
                  height="1px"
                />
              </Text>
              <Button
                mt="-0.2rem"
                color="#03a9f4"
                _hover={{ bgColor: "#d6eef7" }}
                _active={{ bgColor: "#d6eef7" }}
                variant="ghost"
                boxShadow="none !important"
                ml="2rem"
                size="md"
                leftIcon={<IoIosAddCircle color="#03a9f4" size="25px" />}
              >
                Detalhes
              </Button>
            </Flex>
          </Box>
        );
      })}
    </Box>
  );
};
